import { CustomerVpaList } from "./@types";
/**
 * used to transform the vpa object
 *
 * @param vpa
 * @returns {{vpa: *,title: *,iconIntentUrl: *}}
 *
 * [ used primarily in ./customerVpaListTransformer.js ]
 */
export const vpaTransformer = (vpaObj: CustomerVpaList) => ({
  vpa: vpaObj.vpa,
  title: vpaObj.title,
  iconIntentUrl: vpaObj.iconIntentUrl,
  warningMessage: vpaObj.warningMessage,
  offerKeys: vpaObj.offerKeys,
  packageName: vpaObj?.packageName || '',
});
